import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Sales.css';

import ReactPlayer from 'react-player';
import Footer from '../../components/Footer/Footer'


import heroImage from '../../images/sales_banner.jpeg';
import workspaceImage from '../../images/hero-team.jpg';
import moduleImage from '../../images/sales_banner.jpeg';
import testimonial1 from '../../images/avtr.jfif';
import testimonial2 from '../../images/avtr2.jfif';
import testimonial3 from '../../images/avtr.jfif';
import { Link } from 'react-router-dom';

const SalesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);

  const features = [
    {
      icon: '📘',
      title: 'Digital Guides',
      description: 'Step-by-step marketing and business guides to help you take action with clarity.',
      featured: true
    },
    {
      icon: '🤖',
      title: 'AI RESOURCES',
      quote: '"Leverage AI tools to scale your content and marketing efforts."',
      highlight: true
    },
    {
      icon: '📈',
      title: 'Marketing Tools',
      description: 'Growth materials and frameworks designed to improve visibility and results.'
    },
    {
      icon: '💼',
      title: 'Business Resources',
      description: 'Practical resources to help you make better decisions and move forward with confidence.'
    }
  ];

  const benefits = [
    {
      title: 'Clarity Over Guesswork',
      description: 'Get clear direction on what to do next in your business and marketing.'
    },
    {
      title: 'Action-Ready Resources',
      description: 'No fluff. Just practical tools and guides you can implement immediately.'
    }
  ];

  const steps = [
    {
      number: '1',
      title: 'Choose an Offer',
      description: 'Select the digital product or resource that fits your current need.'
    },
    {
      number: '2',
      title: 'Get Access Now',
      description: 'Complete your purchase securely through our payment platform.'
    },
    {
      number: '3',
      title: 'Instant Access',
      description: 'Get immediate access to your digital resource and start implementing.'
    }
  ];

  const offers = [
    {
      title: 'Why Your Ads Aren\'t Converting',
      description: 'Stop wasting money on ads that don\'t bring results. This guide shows you exactly what\'s wrong and what to fix so your ads can start converting.',
      price: '',
      featured: true
    }
  ];

  const testimonials = [
    {
      text: "Oma Media Space doesn't just sell courses; they sell results. Within 30 days of applying the 'Golden Standard', our lead quality improved by 40%.",
      name: 'Marcus Chen',
      role: 'Founder, Nexus Visuals',
      image: testimonial1,
      rating: 5
    },
    {
      text: 'The editorial approach to content was the missing link for us. Finally, our brand looks as expensive as it actually is.',
      name: 'Elena Rodriguez',
      role: 'Marketing Lead, Luxe Collective',
      image: testimonial2,
      rating: 5
    },
    {
      text: 'The purchase process was seamless. I was implementing the strategies less than 2 minutes after clicking buy.',
      name: 'David Okoro',
      role: 'E-com Strategist',
      image: testimonial3,
      rating: 5
    }
  ];

  const userImages = [testimonial1, testimonial2, testimonial3];

  return (
    <>
      <div className="Sales">

        {/* Hero Section */}
        <section className="Sales-hero">
          <div className="Sales-hero-bg">
            <img src={heroImage} alt="Premium marketing masterclass" className="Sales-hero-bg-image" />
            <div className="Sales-hero-bg-overlay"></div>
          </div>
          
          <div className="Sales-hero-content" data-aos="fade-up">
            <span className="Sales-hero-badge">DIGITAL RESOURCES</span>
            
            <h1 className="Sales-hero-title header-1">
              GET CLARITY. <br />
              GET <span className="Sales-hero-title--gold">RESOURCES</span>. <br />
              GET RESULTS.
            </h1>
            
            <p className="Sales-hero-subtitle text-1">
              Access premium digital products, guides, tools, AI, and business resources created to help you grow smarter, market better, and get clearer results.
            </p>
            
            <div className="Sales-hero-actions">
              <Link to='https://selar.com/m/Omamediaspace' target='blank_'>
                <button className="Sales-hero-btn">
                  Get Access Now
                  <span className="Sales-hero-btn-arrow">→</span>
                </button>  
              </Link>

              <div className="Sales-hero-social-proof">
                <span className="Sales-hero-avatars">
                  {userImages.map((img, idx) => (
                    <img key={idx} src={img} alt="" className="Sales-hero-avatar" />
                  ))}
                </span>
                <span className="Sales-hero-social-text text-2">Trusted by 500+ professionals</span>
              </div>
            </div>
          </div>

        </section>

        {/* Intro Section */}
        <section className="Sales-intro">
          <div className="Sales-container">
            <div className="Sales-intro-content" data-aos="fade-up">
              <h2 className="Sales-intro-title header-2">
                Tired of guessing your way through business, marketing, content, or growth?
                
              </h2>
              <p className="Sales-intro-text text-1">
                This page gives you access to carefully created digital products and resources designed to help you make better decisions, improve your visibility, and move your business forward with more confidence.
              </p>
              <div className="Sales-intro-tagline">
                <span className="Sales-intro-tag">Simple.</span>
                <span className="Sales-intro-tag">Practical.</span>
                <span className="Sales-intro-tag">Valuable.</span>
              </div>
            </div>
          </div>
        </section>

        {/* Features - What You'll Find Here */}
        <section className="Sales-features">
          <div className="Sales-container">
            <div className="Sales-features-header" data-aos="fade-up">
              <span className="Sales-features-tag text-2">What You'll Find Here</span>
              <h2 className="Sales-features-title header-2">Resources Built for Growth</h2>
            </div>

            <div className="Sales-features-grid">
              {features.map((feature, idx) => (
                <div
                  key={idx}
                  className={`Sales-feature-card ${
                    feature.featured ? 'Sales-feature-card--featured' : ''
                  } ${feature.highlight ? 'Sales-feature-card--highlight' : ''}`}
                  data-aos="zoom-in"
                  data-aos-delay={idx * 100}
                >
                  {feature.highlight ? (
                    <>
                      <div className="Sales-feature-card-icon-large">{feature.icon}</div>
                      <div className="Sales-feature-card-highlight-content">
                        <h3 className="Sales-feature-card-title--large header-3">{feature.title}</h3>
                        <p className="Sales-feature-card-quote text-1">{feature.quote}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <span className="Sales-feature-card-icon">{feature.icon}</span>
                      <h3 className="Sales-feature-card-title header-3">{feature.title}</h3>
                      <p className="Sales-feature-card-desc text-1">{feature.description}</p>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Video Section - Watch How It Works */}
        {/* <section className="Sales-video">
          <div className="Sales-container">
            <div className="Sales-video-header" data-aos="fade-up">
              <h2 className="Sales-video-title header-2">
                Watch <span className="Sales-video-title--gold">How It Works</span>
              </h2>
              <p className="Sales-video-description text-1">
                Watch the short video below to see exactly how to select an offer, complete your purchase, and get instant access.
              </p>
            </div>

            <div className="Sales-video-player" data-aos="fade-up" data-aos-delay="200">
              <div className='video' data-aos="fade-up">
                <ReactPlayer url="https://www.youtube.com/watch?v=nLb2_z5EVK0" width="100%"/>
              </div>
            </div>
          </div>
        </section> */}

        {/* Available Offers Section */}
        <section className="Sales-offers">
          <div className="Sales-container">
            <div className="Sales-offers-header" data-aos="fade-up">
              <h2 className="Sales-offers-title header-2">Available Offers</h2>
              <p className="Sales-offers-subtitle text-1">
                Start with what you need most to improve your results and make better decisions for your business.
              </p>
            </div>

            <div className="Sales-offers-grid">
              {offers.map((offer, idx) => (
                <div key={idx} className="Sales-offer-card" data-aos="fade-up" data-aos-delay={idx * 100}>
                  <div className="Sales-offer-content">
                    <h3 className="Sales-offer-title header-3">{offer.title}</h3>
                    <p className="Sales-offer-description text-1">{offer.description}</p>
                    <div className="Sales-offer-footer">
                      <span className="Sales-offer-price header-3">{offer.price}</span>

                      <Link to='https://selar.com/m/Omamediaspace' target='blank_'>
                        <button className="Sales-offer-btn">Get Access Now</button>
                      </Link>
                      
                    </div>
                  </div>
                </div>
              ))}

              {/* Coming Soon Card */}
              <div className="Sales-offer-card Sales-offer-card--coming-soon" data-aos="fade-up" data-aos-delay="200">
                <div className="Sales-offer-content">
                  <span className="Sales-offer-badge">Coming Soon</span>
                  <h3 className="Sales-offer-title header-3">More Resources on the Way</h3>
                  <p className="Sales-offer-description text-1">
                    More powerful digital products and resources are currently being developed to help you grow, improve, and scale your business.
                  </p>
                  <p className="Sales-offer-stay-connected text-1">Stay connected.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Product Deep Dive - Why This Works */}
        <section className="Sales-product">
          <div className="Sales-container">
            <div className="Sales-product-grid">
              <div className="Sales-product-content" data-aos="fade-right">
                <h2 className="Sales-product-title header-2">Built on Real Experience</h2>
                <p className="Sales-product-text text-1">
                  Every resource is created from <span className="Sales-product-highlight">years of hands-on marketing and business experience</span>. 
                  We don't just share theory—we share what actually works in the real world.
                </p>
                
                <ul className="Sales-product-benefits">
                  {benefits.map((benefit, idx) => (
                    <li key={idx} className="Sales-product-benefit" data-aos="fade-up" data-aos-delay={idx * 100}>
                      <span className="Sales-product-benefit-icon">✓</span>
                      <div className="Sales-product-benefit-content">
                        <h4 className="Sales-product-benefit-title text-1">{benefit.title}</h4>
                        <p className="Sales-product-benefit-desc text-2">{benefit.description}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="Sales-product-media" data-aos="fade-left">
                <img src={moduleImage} alt="Oma Media Space" className="Sales-product-media-image" />
              </div>
            </div>
          </div>
        </section>

        {/* How to Buy - How It Works */}
        <section className="Sales-steps">
          <div className="Sales-container">
            <div className="Sales-steps-header" data-aos="fade-up">
              <h2 className="Sales-steps-title header-2">How It Works</h2>
              <p className="Sales-steps-subtitle text-1">Simple. Secure. Instant.</p>
            </div>

            <div className="Sales-steps-grid">
              <div className="Sales-steps-line"></div>
              {steps.map((step, idx) => (
                <div key={idx} className="Sales-step-card" data-aos="fade-up" data-aos-delay={idx * 150}>
                  <div className="Sales-step-number">{step.number}</div>
                  <h4 className="Sales-step-title text-1">{step.title}</h4>
                  <p className="Sales-step-desc text-2">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="Sales-testimonials">
          <div className="Sales-container">
            <div className="Sales-testimonials-header" data-aos="fade-up">
              <h2 className="Sales-testimonials-title header-2">What Others Are Saying</h2>
            </div>
            <div className="Sales-testimonials-grid">
              {testimonials.map((testimonial, idx) => (
                <div key={idx} className="Sales-testimonial-card" data-aos="fade-up" data-aos-delay={idx * 100}>
                  {testimonial.rating > 0 && (
                    <div className="Sales-testimonial-rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <span key={i} className="Sales-testimonial-star">★</span>
                      ))}
                    </div>
                  )}
                  <p className="Sales-testimonial-text text-1">"{testimonial.text}"</p>
                  <div className="Sales-testimonial-author">
                    <img src={testimonial.image} alt={testimonial.name} className="Sales-testimonial-avatar" />
                    <div className="Sales-testimonial-info">
                      <h5 className="Sales-testimonial-name text-1">{testimonial.name}</h5>
                      <p className="Sales-testimonial-role text-2">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="Sales-cta">
          <div className="Sales-cta-bg"></div>
          <div className="Sales-cta-content" data-aos="zoom-in">
            <h2 className="Sales-cta-title header-1">
              START WITH WHAT YOU <span className="Sales-cta-title--gold">NEED MOST</span>
            </h2>
            <p className="Sales-cta-subtitle text-1">
              Take the next step toward improving your results and making better decisions for your business.
            </p>
            <div className="Sales-cta-actions">
              <Link to='https://selar.com/m/Omamediaspace' target='blank_'>
                <button className="Sales-cta-btn">Get Access Now</button>
              </Link>

              <p className="Sales-cta-security text-2">
                <span className="Sales-cta-security-icon">🔒</span> Secure Payment via Selar
              </p>
            </div>
          </div>
        </section>

      </div>
      
      {/* <Footer dontShowCTA={true} /> */}
    </>
  );
};

export default SalesPage;

